import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import MatchDots from '../../components/ExcerciseTypes/LineTo/MatchDots';
const json = {
  1: {
    unit: "Unit 1",
    id: "FP8-WB-demo-2023-U1-P10-E1",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page10/Key/E1answerKey.png",
    component: MatchDots,
    stylesTextInput: { borderBottom: 'dotted' },
    fontSize:30,
    inputSize: 35,
    titleQuestion: [
      {
				title: `
				<div style='display:flex'>
				<div style="background-color: rgb(61, 184, 187); border-radius: 50%; color: white; width: 39px; height: 39px; text-align: center; line-height: 39px;margin-right:10px">
				1
				</div>
				Những phép tính nào dưới đây có cùng kết quả?				</div>
				`,
				color: 'rgb(28, 192, 217)',
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    question: {
      DrawLines: {
        
        multipleLine: 2,
        boxMatch: [
          
          {

            boxMatchStyle: {
              position: 'absolute',
              top: '97px',
              left: '429px',
              width: '176px',
              height: '87px',
              borderRadius: '50%',
              border: 'none',
              background: 'none',
            },
          }, // 1
          {

            boxMatchStyle: {
              position: 'absolute',
              top: '97px',
              left: '860px',
              width: '176px',
              height: '87px',
              borderRadius: '50%',
              border: 'none',
              background: 'none',
            },
          }, // 2
          {
            boxMatchStyle: {
              position: 'absolute',
              top: '290px',
              left: '186px',
              width: '167px',
              height: '71px',
              borderRadius: '50%',
              border: 'none',
              background: 'none',
            },
          }, // 3
          {
            boxMatchStyle: {
              position: 'absolute',
              top: '287px',
              left: '597px',
              width: '195px',
              height: '67px',
              borderRadius: '50%',
              border: 'none',
              background: 'none',
            },
          }, // 4
          {
            boxMatchStyle: {
              position: 'absolute',
              top: '280px',
              left: '948px',
              width: '164px',
              height: '80px',
              borderRadius: '50%',
              border: 'none',
              background: 'none',
            },
          },//5
          
         
          
           
        ],
        answers: ['0-2', '0-4', '2-4'],
        initialValue: [],
      },
      Layout: `
      
          <div style='display:flexmargin-top:40px;margin-bottom:50px'>
          <input id='0' type= 'boxMatch' />
          <input id='1' type= 'boxMatch' />
          <input id='2' type= 'boxMatch' />
          <input id='3' type= 'boxMatch' />
          <input id='4' type= 'boxMatch' />
          
          
          
          
          
          
        
          <img src='img/FriendsPlus/Page10/E1/1.jpg' width='100%'  /></div>
  
        </div>
      
        
      `,
    },
    
  },
  2: {
		unit: 'Unit Starter',
		id: 'FP8-WB-demo-2023-US-P9-E3',
    exerciseKey: "/img/FriendsPlus/Page10/Key/E2answerKey.png",
		component: T6,
		inputSize: 105,
		maxLength:7,
		
		textareaStyle: { width: 600 },
		stylesTextInput: {
			fontSize: '26px',
			textAlign:'center',
			background:'none',
			fontWeight:'bold'
		},
		titleQuestion: [
			{
				title: `
				<div style='display:flex'>
				<div style="background-color: rgb(61, 184, 187); border-radius: 50%; color: white; width: 39px; height: 39px; text-align: center; line-height: 39px;margin-right:10px">
				2
				</div>
				Đặt tính rồi tính.			</div>
				`,
				color: 'rgb(28, 192, 217)',
			},
		],
		isHiddenCheck: true,
		questions: [
			{
				title: `
			<div style='display:flex'>
			<div>
			<div style='background-color:rgb(243,209,181);border-radius:15px;padding:10px 10px;'>
			5 071 x 9 = #
			</div> 
			<div style='background-color:rgb(243,209,181);border-radius:15px;padding:10px 10px;margin-top:30px'>
			17 218 x 4 = #
			</div>
			</div>
			<div style='margin-left:150px;'>
			<div style='background-color:rgb(243,209,181);border-radius:15px;padding:10px 10px;'>
			56 472 : 8 = # 
			</div> 
			<div style='background-color:rgb(243,209,181);border-radius:15px;padding:10px 10px;;margin-top:30px'>
			91 503 : 7 = #
			</div>
			
			</div>
			</div>

			
			
        `,
				answer: [
				`45 639`,`68 872`,`7 059`,`13 071`,					
				],
			},
		],
	},
  3: {
		unit: 'Unit Starter',
		id: 'FP8-WB-demo-2023-US-P9-E3',
		exerciseKey: '',
		component: T6,
		inputSize: 105,
    isEssay:true,

		textareaStyle: { width:800 },
		stylesTextInput: {
			fontSize: '25px',
			textAlign:'center',
			background:'none'
		},
		titleQuestion: [
			{
				num: '3',
				title: `
        Có 4 xe ô tô, mỗi xe chở 4 500 kg gạo đến giúp đỡ đồng bào vùng bị lũ lụt. <br>
        Dự kiến tất cả số gạo đó được chia điều cho 5 xã. Hỏi mỗi xã sẽ nhận được bao nhiêu ki-lô-gam gạo?
						`,
				color: 'rgb(28, 192, 217)',
			},
		],
		isHiddenCheck: true,
		questions: [
			{
				title: `
      
        <img src ='/img/FriendsPlus/Page10/E3/1.jpg' width='100%'/>
		<div  style='margin-top:30px' >
        <div style='margin-left:500px'><u><i><b>Bài Giải:</b></i></u></div>
          <div  style='margin-left:150px'> <textarea id='0' rows='3'></textarea></div>
            
        </div>

			
			
        `,
				answer: [
								
				],
			},
		],
	},
  4: {
		unit: 'Unit Starter',
		id: 'FP8-WB-demo-2023-US-P9-E3',
		component: T6,
		// hideBtnFooter: true,
		inputSize: 110,
    exerciseKey: "/img/FriendsPlus/Page10/Key/E4answerKey.png",
		stylesTextInput: {
			fontSize: '26px',
			textAlign:'center'
		},
		titleQuestion: [
			{
				num: '4',
				title: `
				Tính giá trị của biều thức.
				`,
				color: 'rgb(28, 192, 217)',
			},
		],
		isHiddenCheck: true,
		questions: [
			{
				title: `
				<div style='display:flex'>
			<div style='background-color:rgb(192,241,257);border-radius:15px;padding:10px 10px;'>
			a)&ensp;6 000 x 5 : 3 = #
			
			</div>

		 
			<div style='background-color:rgb(192,241,257);border-radius:15px;padding:10px 10px;margin-left:150px;'>
			b)&ensp;13 206 x (36 : 9) = #
			</div>
			
			</div>
        `,
				answer: [`10 000`,`52 824`],
			},
		],
	},
  
};

export default json;
